import useLinkSection from 'Webapp/shared/app/components/notifications/notification-text-click-strategies/use-link-section';
import { FlapNotificationType } from 'Webapp/enums';
export default useLinkSection(FlapNotificationType.FOLLOW);
